<template>
<div>
  <div class="container">
    <div id="attribution-node"></div>
    <loading :active.sync="loading"></loading>
    <div class="row top-row">
      <div class="col-sm-6 my-auto">
        <h1>Dashboard</h1>
      </div>
      <div class="col-sm-6 my-auto">
        <h1>Welcome, {{ getCompanyName }}</h1>
      </div>
    </div>
    <div class="row" v-if="!premium">
      <div class="col-lg-4 my-auto">
        <h2>Packages and Pricing</h2>
        <p>With our Pro plan, you can take your networking and marketing skills to the next level faster.</p>
        <h3 class="no-margin">Your inactive Pro Code is</h3>
        <h3 class="code-display" v-on:click="copyValue(getCompanyId)">{{ getCompanyId }}</h3>
        <p>Remember, codes are case sensitive. Join the Pro plan today to start growing your network by sharing your code with current and potential clients.</p>
      </div>
    </div>
    <div class="row" v-if="premium">
      <div class="col-md-8">
        <h3 class="no-margin">Your Pro Code is Active!</h3>
        <h3 class="code-display" v-on:click="copyValue(getCompanyId)">{{ getCompanyId }}</h3>
        <br/>
        <h4 v-if="link" class="d-inline">Invite clients: </h4><h4 class="code-display d-inline" v-if="link" v-on:click=copyValue(link)>{{ link }}</h4>
        <br/>
        <img v-if="qrCode" v-bind:src="qrCode" class="d-inline">
        <a v-if="qrCode" class="btn btn-primary small-bottom-margin d-inline" v-bind:href="qrCode" download="YarlowQRCode.png">Download QR Code</a>
        <p>Remember, codes are case sensitive. Start growing your network by sharing your code with current and potential clients.</p>
        <h3>What's New?</h3>
        <p>You can now share your Yarlow Pro Code directly from the app! It is easier than ever to connect with your clients and have them keep you top of mind.</p>
      </div>
      <div class="col-md-4">
        <img src="/static/RealtorShareRedCircle.png">
      </div>
    </div>
    <div class="row" v-if="premium">
      <div class="col-md-8">
        <p>Simply open your app, tap the side menu, Share QR Code.</p>
        <p>It's even better than an electronic business card! Your clients can instantly connect with you and get your branded maintenance tips and contact info.</p>
      </div>
      <div class="col-md-4">
        <img src="/static/RealtorQR.png">
      </div>
    </div>
  </div>
  <div class="container" v-if="!premium">
    <div class="row">
      <div class="col-md-6">
        <h4>Why Subscribe?</h4>
        <p>Don't waste your time trying to harvest leads and make social media posts. With Yarlow, simply have your customers scan your Yarlow QR code or text them your custom link and now your company is marked as a preferred pro for the house.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <img src="/static/Realtor.Phone.Drawer.2021.png">
      </div>
      <div class="col-md-6">
        <h4>Referrals</h4>
        <p>What pays more? Referrals or Cold Calling? With the Refer Me feature in the Yarlow app, your customers can share your information easily with others. With each referral, you get an email notification and the referral is added to your Yarlow network. Now they will get your coupons and push-notifications.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h4>Coupons</h4>
        <p>A great way to present a need and sense of urgency to purchase is with a coupon. Don't send print coupons. Yarlow can display your coupons to your Yarlow network and increase your sales.</p>
      </div>
      <div class="col-md-6">
        <img src="/static/Realtor.Task.Ad.2023.png">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    copyValue (value) {
      const el = document.createElement('textarea')
      el.value = value
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
    }
  },
  computed: {
    ...mapGetters('serviceProvider', [
      'getBranchLink',
      'getBranchQRCode',
      'getCompanyId',
      'getCompanyName',
      'getPremium'
    ]),
    ...mapGetters('user', [
      'getNotificationNumber'
    ]),
    link () {
      return this.getBranchLink
    },
    premium () {
      return this.getPremium
    },
    profileImage () {
      if (this.getProfilePicture) {
        return this.getProfilePicture
      } else {
        return '/static/defaultprofile.png'
      }
    },
    qrCode () {
      return this.getBranchQRCode
    }
  }
}
</script>

<style scoped>
.bottom-margin {
  margin-bottom: 6rem;
}

.small-bottom-margin {
  margin-bottom: 1.5rem;
}

.clipboard-container {
  color: #4F4F4F;
  cursor: pointer;
  padding: 4rem 0;
  text-align: center;
}

.code-display {
  color: #0645AD !important;
  cursor: pointer;
  margin: 2rem 0;
}

.container {
  margin-bottom: 1.5rem;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.fa-comments {
  font-size: 3rem;
  color: rgb(254, 237, 170);
}

.no-margin {
  margin: 0;
}

#profile-thumb {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover !important;
}

.to-messaging {
  position: absolute;
  right: 2rem;
  top: 1rem;
}

.top-row {
  padding-bottom: 1rem;
}

.unread-messages {
  position: absolute;
  right: 2.7rem;
  top: 1rem;
  font-size: 1.7rem;
}

.left-realtor-plan-div {
  background-color: rgb(18, 23, 26);
  border-radius: 25px 5px 5px 25px;
  margin-top: 3rem;
  margin-bottom: 3rem;
  text-align: center;
}
.plan-name-text {
  color: white !important;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0rem;
}

.price-text {
  color: white !important;
  font-size: 3rem;
  font-weight: bold;
  margin: 0rem;
}

.right-realtor-plan-div {
  background-color: rgb(48, 73, 94);
  border-radius: 25px;
  text-align: center;
}

.shorten-button {
  margin-bottom: 1rem;
  width: auto !important;
}

.sub-text{
  font-size: 0.85rem;
}

.white-divider {
  background-color: white;
  border-color: white;
}

.white-text {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/serviceProviderProfile/ServiceProviderDashboard.vue